import {Button, capitalize, Stack} from '@mui/material';
import React from 'react';

import {StyledCard, TagChip} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {AppointmentCardContainer} from '../../../../components/AppointmentCard/styles';
import {TAG_TITLE} from './constants';
import {useAppointmentsHistoryCard} from './hooks/useAppointmentsHistoryCard';
import {AppointmentHistoryCardProps} from './types';
import {FavoriteDoctorsLikeButton} from 'presentation/modules/booking/favoriteDoctors/components/FavoriteDoctorsLikeButton';
import {TypeAttendance} from 'presentation/modules/myAppointments/constants/typeAttendanceEnum';

const {goToDetails} = translations['pt-br'].privateFlow.myAppointments.appointmentCard;

export function AppointmentsHistoryCard({
	appointment,
	handleGoToDetails,
	hasTutorialId,
	hasTutorialLikeButtonId,
}: AppointmentHistoryCardProps) {
	const {
		isLaptop,
		iconName,
		variant,
		goToAppointmentDetails,
		formatted,
		appointmentCardInfos,
		bookingType,
	} = useAppointmentsHistoryCard({
		appointment,
		handleGoToDetails,
	});

	return (
		<AppointmentCardContainer elevation={isLaptop ? 0 : 1}>
			<StyledCard.Header
				iconProps={{
					customIconName: iconName,
					variant,
					size: 'smaller',
				}}
				title={capitalize(formatted)}
				titleColor={'text.primary'}
				titleTypographyProps={{
					fontSize: '1rem',
					fontWeight: 600,
				}}
			/>
			<Stack
				flex={1}
				flexDirection="row"
				justifyContent="space-between"
				alignItems="flex-start">
				<StyledCard.Content
					sx={{flexDirection: 'column', gap: 2}}
					list={appointmentCardInfos}
					switchFirstTwoListItemsPosition
				/>
				{appointment.typeAttendance !== TypeAttendance.EMERGENCY && (
					<FavoriteDoctorsLikeButton
						cdPrestador={Number(appointment.provider.code)}
						cdEspecialidade={Number(appointment.specialty.code)}
						cdSubEspecialidade={Number(appointment.subSpecialty)}
						selected={appointment.provider.isFavorite}
						id={hasTutorialLikeButtonId ? 'seeHistoryDetailsLikeButton' : undefined}
					/>
				)}
			</Stack>
			<Stack direction="row" alignItems="center" justifyContent="space-between">
				<TagChip label={TAG_TITLE[bookingType]} color="primary" />
				<Button
					onClick={goToAppointmentDetails}
					variant="text"
					size="small"
					id={hasTutorialId ? 'seeHistoryDetails' : undefined}>
					{goToDetails}
				</Button>
			</Stack>
		</AppointmentCardContainer>
	);
}
